import React, {useState, useEffect} from "react";
import Modal from "../../../common/Modal/Modal";
import { connect, useSelector} from "react-redux";
import {getIndustries} from "../../../../actions/company";

export function RegCreateCompany(props) {

    useEffect(() => {
        props.getIndustries();
    }, []);

    const industries = useSelector(state => state.company.industries);

    useEffect(() => {
        console.log(industries);
    }, [industries]);

    const isCompanyDomainUnique = useSelector(state => state.auth.isCompanyDomainUnique);

    return (
        <Modal hasBackButton={true} handleBack={() => props.handleBack()} className="login" >
            <form className="form" onSubmit={(e) => props.onSubmit(e)}>		
                <div className="inputs-wrapper gap-below-m">
                    <div className="input-basic addspace"> 
                        <input
                            type="text"
                            name="cname"
                            onChange={(e) => props.onChange(e)}
                            id="cname"
                            value={props.newCompany.cname}
                            required
                        />
                        <label htmlFor="cname">Company Name <span>*</span></label>
                    </div> 
                    <div className="input-basic addspace"> 
                        <input
                            type="tel"
                            name="phone"
                            onChange={(e) => props.onChange(e)}
                            id="phone"
                            value={props.newCompany.phone}
                            required
                        />
                        <label htmlFor="phone">Company Phone Number <span>*</span></label>
                    </div>
                    <div className="input-basic addspace"> 
                        <input
                            type="text"
                            name="website_address"
                            onChange={(e) => props.onChange(e)}
                            id="website_address"
                            value={props.newCompany.website_address}
                        />
                        <label htmlFor="website_address">Website</label>
                    </div>
                    <div className="input-basic addspace"> 
                        <input
                            type="text"
                            name="street"
                            onChange={(e) => props.onChange(e)}
                            id="street"
                            value={props.newCompany.street}
                        />
                        <label htmlFor="street">Street Address </label>
                    </div>
                    <div className="input-basic addspace"> 
                        <input
                            type="text"
                            name="city"
                            onChange={(e) => props.onChange(e)}
                            id="city"
                            value={props.newCompany.city}
                            required
                        />
                        <label htmlFor="city">City <span>*</span></label>
                    </div>
                    <div className="input-basic addspace"> 
                        <input
                            type="text"
                            name="state"
                            onChange={(e) => props.onChange(e)}
                            id="state"
                            value={props.newCompany.state}
                            required
                        />
                        <label htmlFor="state">State / Province <span>*</span></label>
                    </div>
                    <div className="input-basic addspace"> 
                        <input
                            type="text"
                            name="country"
                            onChange={(e) => props.onChange(e)}
                            id="country"
                            value={props.newCompany.country}
                            required
                        />
                        <label htmlFor="country">Country <span>*</span></label>
                    </div>
                    <div className="input-basic">										
                        <select 
                            name="industry" 
                            id="industry" 
                            type="number"
                            style={props.newCompany.industry ? {color: "#3C3B41" } : {color: "#919197"}}
                            onChange={(e) => props.onChange(e)}
                            value={props.newCompany.industry}
                            required 
                            >
                            <option value={""} >Industry</option>
                            { industries && industries.map((industry) => {
                                return <option key={industry.id} value={industry.id} >{industry.name}</option>
                            })}
                        </select>
                        <label htmlFor="name">Industry<span> *</span></label>
                    </div>
                    <div style={{marginTop: "48px"}}>
                        <div className="checkbox-wrapper gap-below-xs" >
                            <input 
                                className="typical-checkbox"
                                type="checkbox"
                                id="is_searchable"
                                name="is_searchable"
                                // value={props.newCompany.is_searchable}
                                checked={props.newCompany.is_searchable}
                                onChange={() => props.setNewCompany({...props.newCompany, is_searchable: !props.newCompany.is_searchable })}
                            />
                            <label htmlFor="is_searchable" className="content2 light-black multiline" >Allow other users to search for this company</label>
                        </div>
                        { isCompanyDomainUnique && 
                            <div className="checkbox-wrapper gap-below-xs" >
                                <input 
                                    className="typical-checkbox"
                                    type="checkbox"
                                    id="register_domain"
                                    name="register_domain"
                                    // value={!props.newCompany.register_domain}
                                    checked={props.newCompany.register_domain}
                                    onChange={() => props.setNewCompany({...props.newCompany, register_domain: !props.newCompany.register_domain })}
                                />
                                <label htmlFor="register_domain" className="content2 light-black multiline" >Allow users with <span className="heavy">@{props.newCompany.domain}</span> addresses to sign up as part of this company</label>
                            </div>
                        }
                    </div>
                </div>

                <button type="submit" id="register_company" className="btn pri gap-below-m" disabled={props.isSubmitting} >{props.isSubmitting ? "Registering..." : "Register Company"}</button>
                {/* <p className="content2 light text-center gap-below-s">Your company will be added to 4site.ai and your user account will be created</p> */}
            </form>
            
        </Modal>
    )
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {getIndustries})(RegCreateCompany);